<div class="flex items-center justify-between gap-6 px-4 py-4 sm:px-6 sm:py-4">
  <!-- Logo -->
  <a routerLink="/home">
    <img
      ngSrc="wannacamp-logo.png"
      alt="WannaCamp Logo"
      width="76"
      height="70"
      priority
      class="block h-auto w-[64px] object-contain sm:w-[76px]"
    />
  </a>

  <!-- Menu -->
  <div class="relative md:hidden">
    <button
      type="button"
      class="cursor-pointer border-none bg-transparent p-0"
      (click)="showMenu.set(!showMenu())"
      (clickOutside)="showMenu.set(false)"
    >
      <i class="pi pi-bars text-primary"></i>
    </button>

    @if (showMenu()) {
      <div
        class="fixed bottom-0 right-0 top-0 z-10 mx-2 my-10 h-auto max-h-[calc(100vh-5rem)] w-80 overflow-y-auto rounded-2xl bg-white p-6 shadow-md transition-all duration-300 ease-in-out"
      >
        <div class="mt-0 flex-col gap-12">
          @let currentUser = loggedInUser();

          @if (currentUser) {
            <div class="text-xl font-bold tracking-tighter">
              {{ 'account.welcome_back' | transloco }},
              {{ currentUser.firstName }}
            </div>
            <div>{{ currentUser.email }}</div>

            <p-divider class="py-1" />
          }

          <!-- Navigation items -->
          <nav class="flex flex-col gap-4">
            @for (navigationItem of navigationItems(); track $index) {
              @if (navigationItem.visible) {
                @if (navigationItem.external) {
                  <a
                    class="block cursor-pointer text-inherit no-underline hover:font-bold"
                    [href]="navigationItem.href"
                    target="_blank"
                    rel="noopener"
                  >
                    <div class="flex items-baseline justify-start gap-3">
                      {{ navigationItem.title | transloco }}
                      <span class="sr-only">{{
                        'shared.opens_in_new_tab' | transloco
                      }}</span>
                    </div>
                  </a>
                } @else {
                  <a
                    class="block cursor-pointer text-inherit no-underline hover:font-bold"
                    [routerLink]="navigationItem.link"
                  >
                    @if (navigationItem.title) {
                      <div class="flex items-baseline justify-start gap-3">
                        {{ navigationItem.title | transloco }}
                      </div>
                    }
                  </a>
                }
              }
            }
          </nav>

          <p-divider class="py-1" />

          <!-- Auth items -->
          <nav class="flex flex-col gap-4">
            @for (authItem of authItems(); track $index) {
              @if (authItem.visible) {
                <a
                  class="block cursor-pointer text-inherit no-underline hover:font-bold"
                  (click)="authItem.command?.()"
                  [routerLink]="authItem.link ?? null"
                >
                  <div class="flex items-baseline justify-start gap-3">
                    {{ authItem.title | transloco }}
                  </div>
                </a>
              }
            }
          </nav>
        </div>
      </div>
    }
  </div>

  <!-- Navigation -->
  <div class="hidden items-center justify-end gap-3 md:flex">
    <div class="flex items-center justify-between gap-6">
      <nav class="flex items-center justify-end gap-0">
        @for (navigationItem of navigationItems(); track $index) {
          @if (navigationItem.visible) {
            @if (navigationItem.external) {
              <a
                class="text-primary hover:bg-primary/25 cursor-pointer whitespace-nowrap rounded-2xl px-3 py-2 font-bold no-underline lg:px-6"
                [href]="navigationItem.href"
                target="_blank"
                rel="noopener"
              >
                {{ navigationItem.title | transloco }}
                <span class="sr-only">{{
                  'shared.opens_in_new_tab' | transloco
                }}</span>
              </a>
            } @else {
              <a
                class="text-primary hover:bg-primary/25 cursor-pointer whitespace-nowrap rounded-2xl px-3 py-2 font-bold no-underline lg:px-6"
                [routerLink]="navigationItem.link"
              >
                @if (navigationItem.title) {
                  {{ navigationItem.title | transloco }}
                }
              </a>
            }
          }
        }

        <!-- Languages -->
        <app-languages />
      </nav>

      <nav class="flex items-center justify-end gap-0">
        @for (authItem of authItems(); track $index) {
          @if (authItem.visible) {
            <a
              class="text-primary hover:bg-primary/25 cursor-pointer rounded-2xl px-3 py-2 font-bold no-underline lg:px-6"
              (click)="authItem.command?.()"
              [routerLink]="authItem.link ?? null"
            >
              @if (authItem.title) {
                {{ authItem.title | transloco }}
              }
            </a>
          }
        }
      </nav>
    </div>
  </div>
</div>
